export const testMatch = (string, matchString) => {
  const pattern = new RegExp(matchString);
  return pattern.test(string)
};
